/**
 * Utility functions for route handling and detection
 */

/**
 * Checks if the current route is an admin route
 * @returns {boolean} True if the current route is in the admin section
 */
export function isAdminPaymentsRoute() {
  // Check if the current path starts with /dashboard/
  return window.location.pathname.startsWith('/dashboard/payments');
}

/**
 * Checks if the current route is related to payments
 * @returns {boolean} True if the current route is payment-related
 */
export function isPaymentRoute() {
  return window.location.pathname.includes('payment');
}

/**
 * Checks if we should bypass the PWA for the current route
 * @returns {boolean} True if we should bypass the PWA
 */
export function shouldBypassPWA() {
  // Always bypass PWA for admin routes
  return isAdminRoute();
}
